import classnames from 'classnames';
import { isNumber } from 'lodash';
import React, { memo } from 'react';
import useHelpNoteTitle from '../../utils/Translations/useHelpNoteTitle';
import useLayoutDirection from '../../utils/Translations/useLayoutDirection';
const AnimatedTitle = ({ placeholder, value, isRequired, className, icon, iconPosition = 'right', tooltipTitle, }) => {
    const { direction, startSide } = useLayoutDirection();
    const resolvedTooltipTitle = useHelpNoteTitle(placeholder, tooltipTitle);
    return (<label className={classnames('control-label animate', className, startSide === 'right' ? 'text-right' : 'text-left', {
        'is-visible': isNumber(value) ? !isNaN(value) : Boolean(value),
    })} data-layout-direction={direction} dir={direction} title={resolvedTooltipTitle || placeholder}>
      {iconPosition === 'left' && icon}
      {placeholder}
      {isRequired && <span className="text-danger">&nbsp;*</span>}
      {iconPosition === 'right' && icon}
    </label>);
};
export default memo(AnimatedTitle);
